export default "__VITE_ASSET__b6237b38__"